"use client";

/*eslint-disable */
import React, { useState } from "react";
import AccordionItem from "./AccordionItem";

interface AccordionProps {
  product: any;
}

const Accordion: React.FC<AccordionProps> = ({ product }) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const handleClick = (index: number) => {
    // Alternar el acordeón activo. Si ya está activo, lo colapsa; si no, lo activa.
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq">
      <dl className="faq__list">
        <AccordionItem
          showDescription={activeIndex === 0 ? "show-description" : ""}
          fontWeightBold={activeIndex === 0 ? "font-weight-bold" : ""}
          ariaExpanded={activeIndex === 0}
          title={"Descripción"}
          item={product?.descripcion}
          index={0}
          onClick={() => handleClick(0)}
        />
        <AccordionItem
          showDescription={activeIndex === 1 ? "show-description" : ""}
          fontWeightBold={activeIndex === 1 ? "font-weight-bold" : ""}
          ariaExpanded={activeIndex === 1}
          title={"Usos"}
          item={product?.usos}
          index={1}
          onClick={() => handleClick(1)}
        />
        {/* <AccordionItem
          showDescription={activeIndex === 2 ? "show-description" : ""}
          fontWeightBold={activeIndex === 2 ? "font-weight-bold" : ""}
          ariaExpanded={activeIndex === 2}
          title={"Guia"}
          item={product?.guia}
          index={2}
          onClick={() => handleClick(2)}
        /> */}
      </dl>
    </div>
  );
};

export default Accordion;
